// extracted by mini-css-extract-plugin
export var completionBody = "_mv-2";
export var completionCard = "_mv-0";
export var completionFooter = "_mv-3";
export var completionTitle = "_mv-1";